import clsx from 'clsx';
import { Check, X } from 'lucide-react';
import type { Draft, MultipleChoiceQ } from '../types';
import styles from '../QuizView.module.css';

type Props = {
  question: MultipleChoiceQ;
  draft: Extract<Draft, { format: 'options' }>;
  onChange: (d: Extract<Draft, { format: 'options' }>) => void;
  disabled: boolean;
  showFeedback: boolean;
};

export function MultipleChoice({ question, draft, onChange, disabled, showFeedback }: Props) {
  return (
    <div className={styles.options}>
      {question.options.map((opt, idx) => {
        const isPicked = draft.value === idx;
        const isAnswer = idx === question.correct_answer;
        return (
          <button
            key={idx}
            type="button"
            onClick={() => onChange({ format: 'options', value: idx })}
            className={clsx(
              styles.opt,
              showFeedback && isAnswer && styles.optCorrect,
              showFeedback && isPicked && !isAnswer && styles.optWrong,
              isPicked && !showFeedback && styles.optPicked
            )}
            aria-pressed={isPicked}
            disabled={disabled}
          >
            <span className={styles.optLetter}>{String.fromCharCode(65 + idx)}</span>
            <span className={styles.optText}>{opt}</span>
            {showFeedback && isAnswer && <Check size={18} className={styles.optIcon} />}
            {showFeedback && isPicked && !isAnswer && <X size={18} className={styles.optIcon} />}
          </button>
        );
      })}
    </div>
  );
}
